import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Link, Navigate, useNavigate } from "react-router";

import { authApi, ApiError } from "@/features/mail/api/client";
import { LoginCard } from "@/features/auth/components/LoginCard";

export function LoginPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // 이미 로그인돼 있으면 로그인 화면을 띄우지 않는다.
  const configQuery = useQuery({
    queryKey: ["config"],
    queryFn: authApi.config,
    staleTime: Infinity,
  });

  const meQuery = useQuery({
    queryKey: ["me"],
    queryFn: authApi.me,
    retry: false,
  });

  const login = useMutation({
    mutationFn: (input: { address: string; password: string }) =>
      authApi.login(input.address, input.password),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["me"] });
      void navigate("/", { replace: true });
    },
  });

  if (meQuery.isSuccess) return <Navigate to="/" replace />;

  return (
    <div className="bg-paper flex h-full flex-col items-center justify-center gap-6">
      <LoginCard
        mailDomain={configQuery.data?.mailDomain}
        pending={login.isPending}
        error={
          login.error instanceof ApiError
            ? login.error.message
            : login.error
              ? // 앱 문구는 전부 해요체다. 여기만 합쇼체면 남의 화면처럼 읽힌다.
                "로그인하지 못했어요"
              : null
        }
        onSubmit={(credentials) => login.mutate(credentials)}
      />

      {/* 가입할 길이 화면에 없으면 계정을 만들 방법을 아는 사람만 만든다 */}
      <p className="text-muted text-[13px]">
        아직 계정이 없나요?{" "}
        <Link to="/signup" className="text-link hover:text-link-hover underline">
          계정 만들기
        </Link>
      </p>
    </div>
  );
}
